import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    xhrList: null,
    isSafari: false,
  },
  mutations: {
    getXhrList(state, value) {
      state.xhrList = value;
    },
    geSafari(state, value) {
      state.isSafari = value;
    },
  },
  actions: {},
  modules: {},
});
